<template>
    <FullScreenDialog
        v-model="dialogTerms"
        hideOverlay
        bg="bg-white"
        v-slot="{isBottom}"
        :style="{ zIndex: zIndexTerm }"
    >
        <!-- <TopBarBg :headerText="lbl.register.title.termsAndCond"></TopBarBg> -->
        <div class="pt-20 bg-black bg-opacity-60">

            <PageContent class="px-8 mb-24 pb-2 relative" :hasPoweredBy="false" rounded>
                <div class="text-center pt-2">
                    <div class="text-lg uppercase text-blue-2">{{lbl.register.title.termsAndCond}}</div>
                    <img @click="hideTerms()" class="absolute right-7 top-6 w-4" src="../../../assets/icon/dialog/close.svg" />
                </div>
                <div class="text-base" v-html="termsContent"></div>
            </PageContent>
            <div class="fixed bottom-0 left-0 px-8 py-6 w-full bg-white" v-if="showAcceptButton">
                <VBtn v-if="isBottom"
                    blocked
                    large
                    variant="primary"
                    @click="clickAcceptTerms()"
                >{{ lbl.default.accept }}</VBtn>
                <VBtn v-else
                    blocked
                    large
                    variant="disable"
                >{{ lbl.default.accept }}</VBtn>
            </div>
            <!-- <Footer :hasPoweredBy="false"></Footer> -->
        </div>
    </FullScreenDialog>

    <FullScreenDialog
        v-model="dialogPrivacy"
        hideOverlay
        bg="bg-white"
        v-slot="{isBottom}"
        :style="{ zIndex: zIndexPrivacy }"
    >
        <!-- <TopBarBg :headerText="lbl.register.title.privacy"></TopBarBg> -->
        <div class="pt-20 bg-black bg-opacity-60">
            <PageContent class="px-8  mb-24 pb-2 relative" :hasPoweredBy="false" rounded>
                <div class="text-center pt-2 pb-4">
                    <div class="text-lg uppercase text-blue-2">{{lbl.register.title.privacy}}</div>
                    <img @click="hidePrivacy()" class="absolute right-7 top-6 w-4" src="../../../assets/icon/dialog/close.svg" />
                </div>
                <div class="text-base" v-html="privacyContent"></div>
            </PageContent>
        </div>

        <div class="fixed bottom-0 left-0 px-8 py-6 w-full bg-white" v-if="showAcceptButton">
            <VBtn
                v-if="isBottom"
                blocked
                large
                variant="primary"
                @click="clickAcceptPrivacy()"
            >{{ lbl.default.accept }}</VBtn>
            <VBtn v-else
                blocked
                large
                variant="disable"
            >{{ lbl.default.accept }}</VBtn>
        </div>
        <!-- <Footer :hasPoweredBy="false"></Footer> -->
    </FullScreenDialog>

    <FullScreenDialog
        v-model="dialogMarketing"
        hideOverlay
        bg="bg-white"
        :style="{ zIndex: zIndexPrivacy }"
    >
        <!-- <TopBarBg :headerText="lbl.register.title.privacy"></TopBarBg> -->
        <div class="pt-20 bg-black bg-opacity-60">
            <!-- <PageContent class="px-8  mb-24 pb-2 relative" :hasPoweredBy="false" rounded> -->
            <PageContent class="px-8 pb-2 relative" :hasPoweredBy="false" rounded>
                <div class="text-center pt-4 pb-4">
                    <div class="text-lg uppercase text-blue-2">{{lbl.register.title.marketing}}</div>
                    <img @click="hideMarketing()" class="absolute right-7 top-6 w-4" src="../../../assets/icon/dialog/close.svg" />
                </div>
                <!-- <div class="text-base h-80 overflow-y-auto py-5" v-html="marketingContent"></div> -->
                <div class="text-base h-full overflow-y-auto py-5" v-html="marketingContent"></div>
                <!-- <div class="text-center text-blue-2 mt-6" v-html="lbl.register.body.mkt_title"></div> -->
                <!-- <div class="mt-4">
                    <div class="flex justify-between mb-4 items-center">
                        <div>{{lbl.register.body.mkt_all}}</div>
                        <div @click="handleToggleMkt('all')">
                            <img v-if="mktObject.all" class="h-6 w-auto" src="../../../assets/icon/dialog/toggle_active.png" />
                            <img v-else class="h-6 w-auto" src="../../../assets/icon/dialog/toggle_inactive.png" />
                        </div>
                    </div>
                    <div class="flex justify-between mb-4 items-center">
                        <div>{{lbl.register.body.mkt_email}}</div>
                        <div @click="handleToggleMkt('email')">
                            <img v-if="mktObject.email" class="h-6 w-auto" src="../../../assets/icon/dialog/toggle_active.png" />
                            <img v-else class="h-6 w-auto" src="../../../assets/icon/dialog/toggle_inactive.png" />
                        </div>
                    </div>
                    <div class="flex justify-between mb-4 items-center">
                        <div>{{lbl.register.body.mkt_sms}}</div>
                        <div @click="handleToggleMkt('sms')">
                            <img v-if="mktObject.sms" class="h-6 w-auto" src="../../../assets/icon/dialog/toggle_active.png" />
                            <img v-else class="h-6 w-auto" src="../../../assets/icon/dialog/toggle_inactive.png" />
                        </div>
                    </div>
                    <div class="flex justify-between mb-4 items-center">
                        <div>{{lbl.register.body.mkt_noti}}</div>
                        <div @click="handleToggleMkt('noti')">
                            <img v-if="mktObject.noti" class="h-6 w-auto" src="../../../assets/icon/dialog/toggle_active.png" />
                            <img v-else class="h-6 w-auto" src="../../../assets/icon/dialog/toggle_inactive.png" />
                        </div>
                    </div>
                </div> -->
            </PageContent>
        </div>

        <div class="fixed bottom-0 left-0 px-8 py-6 w-full bg-white" v-if="showAcceptButton">
            <VBtn
                v-if="isEnableMkt"
                blocked
                large
                variant="primary"
                @click="clickAcceptMarketing()"
            >{{ lbl.default.accept }}</VBtn>
            <VBtn v-else
                blocked
                large
                variant="disable"
            >{{ lbl.default.accept }}</VBtn>
        </div>
        <!-- <Footer :hasPoweredBy="false"></Footer> -->
    </FullScreenDialog>
</template>

<script>
import FullScreenDialog from "@/components/Dialog/FullScreenDialog.vue"
// import TopBarBg from "@/components/Layout/TopBar/TopBarBg.vue"
import PageContent from "@/components/Layout/Content/PageContent.vue"
// import Footer from "@/components/Layout/Footer/Footer.vue"
import VBtn from "@/components/Button/VBtn.vue"

//mixin
import LocaleMixin from "@/mixin/LocaleMixin.js";
import ErrorApiMixin from "@/mixin/ErrorApiMixin.js";
//service
import BzbsPDPA from "@/core/PDPA/service/BzbsPDPA.js";

export default {
    name: "TermsAndCondition",
    mixins: [LocaleMixin, ErrorApiMixin],
    props: {
        modalController: Object,
        terms: {
            type: Boolean
        },
        privacy: {
            type: Boolean
        },
        marketing: {
            type: Boolean
        },
        showAcceptButton: {
            type: Boolean
        }
    },
    components: {
        // TopBarBg,
        PageContent,
        // Footer,
        FullScreenDialog,
        VBtn
    },
    emits: ["update:terms", "update:privacy"],
    data: function () {
        return {
            acceptTerm: false,
            acceptPrivacy: false,
            acceptMarketing: false,
            dialogTerms: false,
            dialogPrivacy: false,
            dialogMarketing: false,
            zIndexTerm: 1,
            zIndexPrivacy: 2,
            termsContent: '',
            termsVersion: 0,
            privacyContent: '',
            privacyVersion: 0,
            marketingVersion: 0,
            marketingContent: '',
            mktObject: {
                all: false,
                email: false,
                sms: false,
                noti: false,
                option: false,
            },
            // isEnableMkt: false,
            isEnableMkt: true,
        }
    },
    computed: {

    },
    created: function () {
        this.setupTermsAndPrivacy()
    },
    mounted: function () {

    },
    methods: {
        //#region loading content
        setupTermsAndPrivacy: function () {
            BzbsPDPA.apiGetPDPAVersion().subscribe(
                {
                    next: (data) => {
                        this.termsVersion = data.terms.current_version
                        this.privacyVersion = data.privacy.current_version
                        this.marketingVersion = data.marketing.current_version

                        this.apiGetTerms()
                        this.apiGetPrivacy()
                        this.apiGetMarketing()
                    },
                    error: (err) => {
                        this.errorApi(err)
                    }
                }
            )
        },
        apiGetTerms: function () {
            BzbsPDPA.apiGetPDPAContent('terms', this.termsVersion, this.localeCode + '.txt').subscribe({
                next: (data) => {
                    this.termsContent = data
                },
                error: (err) => {
                    this.errorApi(err)
                }
            })
        },
        apiGetPrivacy: function () {
            BzbsPDPA.apiGetPDPAContent('privacy', this.privacyVersion, this.localeCode + '.txt').subscribe({
                next: (data) => {
                    this.privacyContent = data
                },
                error: (err) => {
                    this.errorApi(err)
                }
            })
        },
        apiGetMarketing: function () {
            BzbsPDPA.apiGetPDPAContent('marketing', this.marketingVersion, this.localeCode + '.txt').subscribe({
                next: (data) => {
                    this.marketingContent = data
                },
                error: (err) => {
                    this.errorApi(err)
                }
            })
        },
        //#endregion
        clear: function () {
            this.acceptTerm = false
            this.acceptPrivacy = false

            this.monitorValues()
        },
        autoOpen: function () {
            if (!this.acceptTerm) {
                this.showTerms()
                return
            }

            if (!this.acceptPrivacy) {
                this.showPrivacy()
                return
            }
        },
        showTerms: function () {
            this.dialogTerms = true
        },
        showPrivacy: function () {
            this.dialogPrivacy = true
        },
        showMarketing: function () {
            this.dialogMarketing = true
        },
        hideTerms: function () {
            this.dialogTerms = false
        },
        hidePrivacy: function () {
            this.dialogPrivacy = false
        },
        hideMarketing: function () {
            this.dialogMarketing = false;
        },
        clearMkt: function () {
            this.dialogMarketing = false;
            this.mktObject.all = false;
            this.mktObject.email = false;
            this.mktObject.sms = false;
            this.mktObject.noti = false;
            this.mktObject.option = false;
            // this.isEnableMkt = false;
            this.isEnableMkt = true;
        },
        clickAcceptTerms: function () {
            this.acceptTerm = true
            this.hideTerms()
            this.$emit("update:terms", true)
        },
        clickAcceptPrivacy: function () {
            this.acceptPrivacy = true
            this.hidePrivacy();
            this.$emit("update:privacy", true)

        },
        clickAcceptMarketing: function () {
            this.mktObject.sms = true;
            this.acceptMarketing = true
            this.hideMarketing();
            this.$emit("update:marketing", true)
        },
        monitorValues: function () {
            if (this.acceptTerm && this.acceptPrivacy) {
                this.$emit("update:modelValue", true)
                this.hideTerms()
                this.hidePrivacy()
                this.zIndexTerm = 1
                this.zIndexPrivacy = 2
            } else {
                this.$emit("update:modelValue", false)
            }
        },
        getVersions: function () {
            return {
                terms: this.termsVersion,
                privacy: this.privacyVersion,
                marketing: this.mktObject,
                marketingVersion: this.marketingVersion
            }
        },
        handleToggleMkt: function (type) {
            if (type == 'email') {
                this.mktObject.email = !this.mktObject.email;
            }
            if (type == 'sms') {
                this.mktObject.sms = !this.mktObject.sms;
            }
            if (type == 'noti') {
                this.mktObject.noti = !this.mktObject.noti;
            }
            if (type == 'all') {
                this.mktObject.all = !this.mktObject.all;
                if (this.mktObject.all) {
                    this.mktObject.email = true;
                    this.mktObject.sms = true;
                    this.mktObject.noti = true;
                } else {
                    this.mktObject.email = false;
                    this.mktObject.sms = false;
                    this.mktObject.noti = false;
                }

            }
            if (this.mktObject.email && this.mktObject.sms && this.mktObject.noti) {
                this.mktObject.all = true;
            } else {
                this.mktObject.all = false;
            }
            if (this.mktObject.email || this.mktObject.sms || this.mktObject.noti) {
                this.mktObject.option = true;
            }
            this.handleMktBtn();
        },
        handleMktBtn: function () {
            if (!this.mktObject.email && !this.mktObject.sms && !this.mktObject.noti && !this.mktObject.all) {
                this.isEnableMkt = false;
            } else {
                this.isEnableMkt = true;
            }
        }
    }
}
</script>
